import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
  return { styleFooter: { color: 'rgba(0, 0, 0, 0.5)', fontSize: '0.9rem' } };
});

export default useStyles;
